import React from "react";
import HeaderComponent from "./UI/HeaderComponent";
import style from "../Assets/css/dashboard_component.css";



import FooterComponent from "./UI/FooterComponent";
import Tabs from "./UI/Tabs";
import EUCommunicationRecordAnalyticsComponent from "./EUCommunicationRecordAnalyticsComponent";
import EUCommunicationRecordReportingComponent from "./EUCommunicationRecordReportingComponent";
import EUCommunicationRecordsOrdersComponent from "./EUCommunicationRecordsOrdersComponent";
import EUCommunicationRecordTransactionsComponent from "./EUCommunicationRecordTransactionsComponent";
import EUClientOrderComponent from "./EUCommunicationRecordClientOrderComponent";
import EUCommunicationRecordClientOrderComponent from "./EUCommunicationRecordClientOrderComponent";

const EUCommunicationRecordDashboardComponent = () => {
  return (
    
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <HeaderComponent  visibility={true}/>
      <div style={{ flex: 1 }}>
        <Tabs>
          <div className={style.tab1} label="Analytics">
            <EUCommunicationRecordAnalyticsComponent />
          </div>
          <div className="tab2" label="Reporting">
            <EUCommunicationRecordReportingComponent />
          </div>
          <div className="tab2" label="Orders">
            <EUCommunicationRecordsOrdersComponent />
          </div>
          <div className="tab2" label="Transactions">
            <EUCommunicationRecordTransactionsComponent />
          </div>
          <div className="tab2" label="Client Order">
            <EUCommunicationRecordClientOrderComponent/>
          </div>
        </Tabs>
      </div>
      <FooterComponent />
      </div>
    
  );
};

export default EUCommunicationRecordDashboardComponent;
